import type { MarketDto } from './marketContracts'
import type { Market } from '../types/marketTypes'

export function parseMarket(dto: MarketDto): Market {
  return {
    id: dto.id,
    name: dto.market_name ?? '',
    code: dto.market_code ?? '',
    country: '',
    countryId: '',
    regulatoryBody: dto.regulatory_body ?? '',
    status: dto.is_active ? 'Active' : 'Inactive',
    activeProperties: 0,
  }
}

export function parseMarketList(data: unknown): Market[] {
  const rows = Array.isArray(data) ? data : (data as { data?: unknown })?.data
  if (!Array.isArray(rows)) return []
  return rows.map(parseMarket)
}
